/* eslint-disable */
import copimaLogo from '../../Components/Login/icons/copima-logo.png';
import featureCatalogue from '../../Components/Login/icons/feature-catalogue.png';
import featureOrders from '../../Components/Login/icons/feature-orders.png';
import featurePromo from '../../Components/Login/icons/feature-promo.png';
import featureNews from '../../Components/Login/icons/feature-news.png';

const defaultFeatures = [
  { icon: <img src={featureCatalogue} alt="" className="w-4 h-4 object-contain" />, label: 'Consulter notre catalogue' },
  { icon: <img src={featureOrders}    alt="" className="w-4 h-4 object-contain" />, label: 'Passer vos commandes en toute simplicité' },
  { icon: <img src={featurePromo}     alt="" className="w-4 h-4 object-contain" />, label: 'Consulter nos articles/familles en promotion' },
  { icon: <img src={featureNews}      alt="" className="w-4 h-4 object-contain" />, label: 'Consulter les nouveautés' },
];

export default function AuthPanel({
  titleLine1 = 'Bienvenue sur votre',
  titleLine2 = 'solution EDGE',
  features = defaultFeatures,
}) {
  const hasTitle = Boolean(titleLine1 || titleLine2);
  const hasFeatures = Array.isArray(features) && features.length > 0;

  return (
    <div
      className="flex flex-col justify-center items-start text-left text-white w-full h-full px-2 ml-32 shrink-0"
      style={{ textShadow: '0 1px 6px rgba(0,0,0,0.55)', marginTop: '-70px' }}
    >
      <div className="flex items-center justify-center mb-10">
        <img src={copimaLogo} alt="Copima" className="h-16 w-auto drop-shadow-lg" />
      </div>

      {hasTitle && (
        <h1 className="text-5xl font-extrabold leading-tight mb-8 pb-4 drop-shadow-lg">
          {titleLine1}
          <br />
          {titleLine2}
        </h1>
      )}

      {hasFeatures && (
        <ul className="space-y-4 text-left">
          {features.map((feature, i) => (
            <li key={i} className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-white/30 flex items-center justify-center mb-1 shrink-0" style={{ boxShadow: '0 4px 16px rgba(255,255,255,0.15)' }}>
                {feature.icon}
              </div>
              <span className="text-base font-semibold text-white">{feature.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
